import {  useRef, useState } from "react";
import LayoutNode, { AttributeCollection, getNodeComponentAttributeValue, setNodeComponentAttributeValue } from "vagaro-website-rendering/src/components/Definitions/LayoutNode";
import { AttributeFieldProps } from "./RenderAttributeInput";
import { GetComponentOrStyleValueFromDefinition } from "../Data/WBData";
import DeleteIcon from "../Icons/DeleteIcon";
import { SortableContext, arrayMove, rectSortingStrategy, sortableKeyboardCoordinates, useSortable } from "@dnd-kit/sortable";
import { DndContext, DragEndEvent, KeyboardSensor, PointerSensor, closestCenter, useSensor, useSensors } from "@dnd-kit/core";
import HamburgerIcon from "vagaro-website-rendering/src/components/Icons/Hamburger";
import { CreateBlankLayoutNode } from "../WBCanvas";
import { wBComponentTypeNames } from "vagaro-website-rendering/src/components/Definitions/WBComponentTypeNames";
import DOMPurify from "dompurify";
import HoverToolTip from "../HoverToolTip";


const maxNumOfTabs = 12;

export default function TabsInputField({label,definition,layoutObject,updateFunc,screenSize,siteData,saveFunc}:AttributeFieldProps){


    let node = layoutObject as LayoutNode;

    if(node.typename!=wBComponentTypeNames.tabRow){
        node = node.parent as LayoutNode;
    }
    const val = GetComponentOrStyleValueFromDefinition(definition,node,screenSize);
    let split = val.split("\n");
    const handleTabComponentChildren = true;

    let parsedLines = split.map((line:string,index:number)=>{return {val:line,id:index+1}});

    if(parsedLines.length!=node.children.length){
        if(parsedLines.length>node.children.length){
            parsedLines = parsedLines.slice(0,node.children.length);
        }
        else{
            for(let i = 0;i<node.children.length;i++){
                if(!parsedLines[i]){
                    parsedLines[i] = {val:"",id:i+1};
                }
            }
        }
    }

    const [lines,setLines] = useState(parsedLines);
    const [toggleUpdate,setToggleUpdate] = useState(false);

    (window as any).updateTabInput = ()=>{setToggleUpdate(!toggleUpdate)};

    const currentId  = useRef(parsedLines.length+10);
    const sensors = useSensors(
        useSensor(PointerSensor),
        useSensor(KeyboardSensor, {
            coordinateGetter: sortableKeyboardCoordinates,
        })
    );

    const getStringFromLines = (inLines:any[])=>{
         return  inLines.map((line)=>line.val).join("\n")
    }

    const updateLineText = (index:number,text:string)=>{
        let newLines = [...lines];
        newLines[index].val = text;
        setLines(newLines);
        updateFunc(definition.attKey,getStringFromLines(newLines),definition.targetType);

    }

    const deleteTabChild = (index:number)=>{
        if(siteData.designer&&handleTabComponentChildren){

           
            let child = node.children[index];
            if(child){

                siteData.designer.deleteObjectById(child.id,true);
                let num = parseInt(getNodeComponentAttributeValue(node,"selectedTab","0"));
                if(num==index){
                    setNodeComponentAttributeValue(node,"selectedTab","0");
                }

            }
            else{
                console.log("no child");
            }
        }
        else{
            console.log("no designer");
        }

    }
    const moveTabChild = (from:number,to:number)=>{
        if(siteData.designer&&handleTabComponentChildren){

          
            node.children =   arrayMove(node.children,from,to);
            for(let i = 0;i<node.children.length;i++){
                node.children[i].childIndex = i;
             
                node.children[i]?.forceUpdate&&node.children[i].forceUpdate();
            }

          
        }

    }

    const addTabChild = (index:number)=>{
        if(siteData.designer&&handleTabComponentChildren){
            let designer =siteData.designer;
            let parent = node;
            let newNode = CreateBlankLayoutNode(wBComponentTypeNames.tabContainer);
            

            //copy styling from last tab
            if(parent.children.length>1){
                let sibling = parent.children[index-1];
                if(sibling){
                    let styling = sibling.screenSizeStyleAttributes;
                    newNode.screenSizeStyleAttributes = [{...styling[0]},{...styling[1]}, {...styling[2]}];
                }
            
            
            }

            designer.moveComponentByObj(newNode,parent,index);
        
        }
    }

    const deleteLine = (index:number)=>{
        if(lines.length<=1)
            return;
        let newLines = [...lines];
        newLines.splice(index,1);
        setLines(newLines);
        updateFunc(definition.attKey,getStringFromLines(newLines),definition.targetType);
        deleteTabChild(index);
    }


    const addLine = ()=>{
        let newLines = [...lines];
        newLines.push({val:"",id:currentId.current++});
        setLines(newLines);
        updateFunc(definition.attKey,getStringFromLines(newLines),definition.targetType);
        addTabChild(newLines.length-1);
    }

    const handleDragEnd = (event: DragEndEvent) => {

        const { active, over } = event;

    

        if (active.id !== over?.id) {

            const oldIndex = lines.findIndex((item) => item.id === active.id);
            let newIndex = lines.findIndex((item) => item.id === over?.id);

            let currentIndex = parseInt(getNodeComponentAttributeValue(node,"selectedTab","0"));

            if(newIndex>=0&&oldIndex>=0){

                const newLines = arrayMove(lines, oldIndex, newIndex);
                setLines(newLines);
                updateFunc(definition.attKey,getStringFromLines(lines),definition.targetType);
                moveTabChild(oldIndex,newIndex);
                
                
                if(oldIndex<currentIndex&&newIndex>=currentIndex){
                    setNodeComponentAttributeValue(node,"selectedTab",(currentIndex-1).toString());
                }
                else if(oldIndex>currentIndex&&newIndex<=currentIndex){
                    setNodeComponentAttributeValue(node,"selectedTab",(currentIndex+1).toString());
                }
                else if(oldIndex==currentIndex){
                    setNodeComponentAttributeValue(node,"selectedTab",newIndex.toString());
                }
                else if(newIndex==currentIndex){
                    setNodeComponentAttributeValue(node,"selectedTab",oldIndex.toString());
                }

                updateFunc(definition.attKey,getStringFromLines(newLines),definition.targetType);
                node.forceUpdate&&node.forceUpdate();
              
            }
            
        }




    };

    let selectedTab = parseInt(getNodeComponentAttributeValue(node,"selectedTab","0"));

    return( 
        <div className="wb-input-group">
            <label className={(val==""||val=="1")?"not-updated":"updated"} >{label}</label>
            <div className="flex-column">
            <DndContext
                            sensors={sensors}
                            collisionDetection={closestCenter}
                            onDragEnd={handleDragEnd}
                        >

                            <SortableContext
                                items={lines}
                                strategy={rectSortingStrategy}

                            >
                {lines.map((line,index)=>{
                    return  <RenderTabLine isCurrent={selectedTab==index}  node={node} allLines={lines} key={line.id} line={line} updateFunc={updateLineText} deleteFunc={deleteLine} index={index}/>
                })}
                </SortableContext>
                </DndContext>
                {lines.length<maxNumOfTabs?
                <div className="wb-input-row">
                    <button  className="invisible-button" onClick={(e)=>{addLine()}} >+ Add Tab &nbsp;<span style={{fontSize:"14px",fontWeight:"400",opacity:".6"}}>{"  "+lines.length+"/"+maxNumOfTabs}</span></button>
                </div>
                :
                <div className="wb-input-row center-all" style={{fontWeight:"400",opacity:".5"}}>
                    Maximum Number of Tabs
                </div>
                    }

            </div>
        </div>
    );



}

function RenderTabLine({isCurrent, allLines, line,updateFunc,deleteFunc,index,node}:{isCurrent:boolean,node:AttributeCollection,allLines:any[],index:number,line:{val:string,id:number},deleteFunc:(index:number)=>void,updateFunc:(index:number,text:string)=>void}){

    const {
        isDragging,
        attributes,
        listeners,
        setNodeRef,
        transform,
        transition
    } = useSortable({ id: line.id });

    const style = {
        transform: transform ? `translate3d(${transform.x}px, ${transform.y}px, 0)` : undefined,
        transition: transition ?? undefined,
        zIndex: isDragging ? 5 : undefined,
        paddingTop:"8px",
     
        
    };

    return   (
    <div className="wb-input-row flex-row gap-small  w-full"

    style={style} ref={setNodeRef}>
         { allLines.length>1&& <div className="drag-handle" style={{cursor:"move"}}  {...attributes}  {...listeners}><HamburgerIcon/></div>}
        <br/>
        <input style={{padding:"8px"}} maxLength={32} className="w-full" placeholder={`Tab ${index+1}...`} key={index} defaultValue={line.val} onChange={(e)=>{

            e.target.value = DOMPurify.sanitize(e.target.value);

            updateFunc(index,e.target.value);
        
        }}/>
        { allLines.length>1&&<>
        <div className="invisible-button center-all"
            style={{width:"30px",maxWidth:"30px"}}
            onClick={(e)=>{
    
                setNodeComponentAttributeValue(node,"selectedTab",index.toString());
                let n = node as LayoutNode;
                n?.forceUpdate&&n.forceUpdate();
                (window as any).updateTabInput&&(window as any).updateTabInput();
        
            }}
        >
            {isCurrent?<TabSelectedIcon/> :<><TabNotSelectedIcon/> <HoverToolTip text="View This Tab" /></>}
           
             </div>
        <div className="invisible-button" style={{color:"darkred",visibility:(isDragging?"hidden":"visible")}} onClick={(e)=>{deleteFunc(index)}} >
            <HoverToolTip text="Delete Tab" />
            <DeleteIcon/>
        </div>
        </>
        }
   
    </div>
    );
}


function TabSelectedIcon(){
return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" fill="#333" height="1em"><path d="M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm256-96a96 96 0 1 1 0 192 96 96 0 1 1 0-192z"/></svg>
}

function TabNotSelectedIcon(){
return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"fill="#333" height="1em" ><path d="M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256z"/></svg>
}